<template>
  <div class="service-detail">
    <service-section v-if="isShowProductInfo" :label="topLabel">
      <ticket-info :info="businessInfo" :type="ticketType"></ticket-info>
    </service-section>
    <service-section label="服务信息">
      <div class="service-info">
        <p class="service-info-title">
          {{ ticketInfo.ticketTitle }}
          <span :class="{ process: isProcess }" class="service-info-status">{{
            serviceStatusToStr(ticketInfo.ticketStatus)
          }}</span>
        </p>
        <p class="service-info-sub" v-if="ticketInfo.createTime">
          <span class="service-label">创建时间</span>{{ ticketInfo.createTime | formatTime }}
        </p>
        <p class="service-info-sub" v-if="+ticketInfo.estimatedFinishTimeStatus > 0">
          <span v-if="+ticketInfo.timeOutStatus === 2" :class="{ active: +ticketInfo.timeOutStatus === 2 }" class="process-item-status">{{ticketInfo.expectedTimeDesc}}</span>
          <span v-if="+ticketInfo.timeOutStatus === 1" class="process-item-status">系统已帮您催单，加急处理中，请您耐心等待哦~</span>
        </p>
        <div v-show="logicIsVisible" class="service-info-btn-group">
          <div v-show="isShowUpdate" class="service-info-btn" @click="handleCancelAppointMent">
            <span>取消预约</span>
          </div>
          <div v-show="isShowUpdate" class="service-info-btn" @click="handleTimeSelect(true)">
            <span>修改预约时间</span>
          </div>
          <div v-show="isShowAppointMent" class="service-info-btn" @click="handleTimeSelect(false)">
            <span>预约回电</span>
          </div>
          <div class="service-info-btn" @click="toLeaveMessage">
            <span>留言</span>
          </div>
          <div class="service-info-btn" @click="promptTicket">
            <span>催单</span>
          </div>
          <div v-show="isShowArbitration" class="service-info-btn" @click="handleArbitration">
            <span>补充举证</span>
          </div>
        </div>
      </div>
    </service-section>
    <service-section v-if="appointmentInfo.length > 0" label="预约信息">
      <div class="service-appointment" v-for="(item, idx) in appointmentInfo" :key="idx">
        <div class="service-appointment-wrap">
          <p class="service-appointment-time">
            <span class="service-label">预约时间</span>
            {{ item.appointmentTime | formatTime }}
          </p>
          <p class="service-appointment-status">
            <span class="service-label">预约状态</span>
            <span :class="{ red: +item.appointmentStatus === 2 }">{{
              appointStatusToStr(item.appointmentStatus)
            }}</span>
          </p>
        </div>
      </div>
    </service-section>
    <service-section v-if="showEvaluationSection && evaluationInfo.recordId" label="评价信息">
      <ticket-evaluation
        :recordId="evaluationInfo.recordId"
        :ticketId="ticketId"
        @evaluate-success="onEvaluateSuccess"
      ></ticket-evaluation>
    </service-section>
    <service-section label="服务流水">
      <ticket-pipeline :info="ticketLogsInfo"></ticket-pipeline>
    </service-section>
    <z-popup v-model="timeSelectShow" position="bottom">
      <z-picker
        title="预约时间"
        :columns="columns"
        @confirm="onConfirm"
        @change="onChange"
        @cancel="onCancel"
      />
    </z-popup>
  </div>
</template>

<script>
import { lego } from '@zz-common/lego'
import native from '@zz-common/native-adapter'
import { Popup, Picker, Dialog } from '@zz-common/zz-ui'
import ServiceSection from '../components/service-section/index'
import TicketPipeline from './ticket-pipeline/index'
import TicketInfo from './ticket-info/index'
import TicketEvaluation from './ticket-evaluation/index'
import {
  getTicketDetailForUser,
  getPeriodsForAppointment,
  operationAppInfo,
  getTicketLogsForUser,
  userUrgetTicket
} from '../../../api/resourceApi'
import { getCookie } from '../../../lib/utils'
import { toast } from '../../../native'
import CallApp from '@zz-common/call-app'
import { url } from '@zz-common/zz-utils';

export default {
  name: 'ServiceProcessDetail',
  components: {
    ServiceSection,
    TicketInfo,
    TicketPipeline,
    TicketEvaluation,
    'z-popup': Popup,
    'z-picker': Picker
  },
  data() {
    return {
      ticketId: this.$route.params.ticketId || '',
      ticketType: '', // 工单类型 0 商品 1订单
      businessInfo: {}, // 订单或商品信息
      ticketInfo: {}, // 工单服务信息
      appointmentInfo: [], // 预约信息
      evaluationInfo: {}, // 评价信息
      ticketLogsInfo: [], // 工单流水信息
      timeSelectEnum: [], // 原始时间选择数据枚举
      columns: [],
      timeSelectShow: false,
      timeSelectMap: {}, // 后端数据处理后的time Map
      isModifyAppointMent: false, // 是否是修改预约
      appointmentSwitch: 0, // 工单配置后端返回是否显示可预约按钮
      fetching: false, // 提交数据flag
      showEvaluationSection: false, // 显示评价区域
      apointFetching: false, // 预约接口是否在拉取中
      curSelectedFirst: '', // 当前选择的第一列值
      ticketHasBeenAssigned: 0 // 工单是否被分配，用来控制预约回电按钮展示
    }
  },
  filters: {
    formatTime(timeStamp) {
      return timeStamp ? new Date(Number(timeStamp)).format('YYYY-MM-DD HH:mm:ss') : ''
    }
  },
  computed: {
    // 商品和订单才显示
    isShowProductInfo() {
      return +this.ticketType === 1 || +this.ticketType === 2
    },
    // 显示预约按钮
    isShowAppointMent() {
      // 未分配的工单不显示按钮
      if (this.ticketHasBeenAssigned === 0) return false
      const appointList = this.appointmentInfo
      if (+this.appointmentSwitch === 0) return false
      if (appointList.length === 0) return true
      const newest = appointList[0]
      const { appointmentStatus } = newest
      return (
        (+appointmentStatus === 0 || +appointmentStatus === 1 || +appointmentStatus === 3) &&
          +this.appointmentSwitch === 1
      )
    },
    // 是否展示补充凭证
    isShowArbitration() {
      const { arbitrationSwitch } = this.ticketInfo
      return +arbitrationSwitch === 1
    },
    // 显示修改和取消
    isShowUpdate() {
      // 未分配的工单不显示按钮
      if (this.ticketHasBeenAssigned === 0) return false
      const appointList = this.appointmentInfo
      if (appointList.length === 0) return false
      const newest = appointList[0]
      const { appointmentStatus } = newest
      return +appointmentStatus === 2 && +this.appointmentSwitch === 1
    },
    logicIsVisible() {
      const { ticketStatus } = this.ticketInfo
      if (+ticketStatus === 3) return false
      return true
    },
    isProcess() {
      const { ticketStatus } = this.ticketInfo
      return +ticketStatus === 1 || +ticketStatus === 2 || +ticketStatus === 4
    },
    topLabel() {
      if (+this.ticketType === 1) return '订单信息'
      if (+this.ticketType === 2) return '商品信息'
      return ''
    }
  },
  created() {
    native.setTitle({
      title: '服务详情'
    })
  },
  mounted() {
    const callappType = url.getHashParam('callappType') || ''
    console.log('url---', url.getHashParam('callappType'), this.$route.params.ticketId || '')
    if (!native.in('zz') && !native.in('zlj') && callappType) {
      // 实例化一次
      const callApp = new CallApp()
      const targetUrl = `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/serviceprocess/detail/${this.$route.params.ticketId || ''}`
      if (callappType == 1) {
        // 唤起转转
        callApp.start({
          path: `zhuanzhuan://jump/core/web/jump?url=${encodeURIComponent(targetUrl)}`,
          targetApp: 'zz',
          callStart() {
            lego.send({
              pagetype: 'ZZKF_C_TICKET_SERVICE_DETAIL',
              actiontype: 'zzCallStart'
            })
          },
          callSuccess() {
            lego.send({
              pagetype: 'ZZKF_C_TICKET_SERVICE_DETAIL',
              actiontype: 'zzCallSuccess'
            })
          }
        })
      } else if (callappType == 2) {
        // 唤起转转
        callApp.start({
          path: `zljgo://native_api?type=1&content=${encodeURIComponent(targetUrl)}`,
          targetApp: 'zlj',
          callStart() {
            lego.send({
              pagetype: 'ZZKF_C_TICKET_SERVICE_DETAIL',
              actiontype: 'zljCallStart'
            })
          },
          callSuccess() {
            lego.send({
              pagetype: 'ZZKF_C_TICKET_SERVICE_DETAIL',
              actiontype: 'zljCallSuccess'
            })
          }
        })
      }
    } else {
      // 此处登录改用native的login
      native.login({
        callback: () => {
          this.initPageInfo()
          lego.send({
            pagetype: 'ZZKF_C_TICKET_SERVICE_DETAIL',
            actiontype: 'PAGE_SHOW'
          })
        }
      })
    }
  },
  methods: {
    formatLogsTime(timeStamp) {
      return Number(timeStamp)
    },
    initPageInfo() {
      this.getTikectInfo()
      this.getLogsInfo()
    },
    serviceStatusToStr(status) {
      const map = {
        1: '处理中',
        2: '处理中',
        3: '已完成',
        4: '处理中'
      }
      return map[status] || ''
    },
    appointStatusToStr(status) {
      const map = {
        0: '已完成',
        1: '已完成',
        2: '未完成',
        3: '取消预约'
      }
      return map[status] || ''
    },
    onEvaluateSuccess() {
      this.showEvaluationSection = false
      this.initPageInfo()
    },
    onCancel() {
      this.timeSelectShow = false
    },
    onChange(picker, values) {
      const firstValue = values[0] || ''
      this.curSelectedFirst = firstValue
      picker.setColumnValues(
        1,
        this.timeSelectMap[firstValue].map((item) => {
          return {
            text: item.disabled ? `${item.timeStr}(约满)` : item.timeStr,
            disabled: item.disabled
          }
        })
      )
    },
    handleTimeSelect(isModify) {
      if (this.apointFetching) return
      this.apointFetching = true
      this.isModifyAppointMent = isModify
      this.getAppointMentInfo()
        .then(() => {
          this.timeSelectShow = true
          this.apointFetching = false
        })
        .catch((_erro) => {
          this.apointFetching = false
        })
    },
    onConfirm(value, index) {
      const selectedDate = this.timeSelectMap[value[0]]
      const selectedTime = selectedDate[index[1]]
      const { disabled } = selectedTime
      // 如果选择的时间是不可选的，不提交结果
      if (disabled) {
        this.timeSelectShow = false
        toast({
          msg: '已约满，请选择其他时间',
          style: '2'
        })
        return
      }
      const params = {
        type: this.isModifyAppointMent ? 1 : 0, // 0 预约 1修改预约
        startTime: selectedTime.startTime,
        endTime: selectedTime.endTime
      }
      this.submitAppointInfo(params)
      this.timeSelectShow = false
    },
    handleArbitration() {
      native.skipToUrl({
        targetUrl: `https://m.zhuanzhuan.com/trade/order_flow_v2/index.html?needHideHead=1&orderId=${this.businessInfo?.id}#/refund-detail`
      })
    },
    handleCancelAppointMent() {
      const params = {
        type: 4 // 4 取消预约
      }
      this.submitAppointInfo(params)
    },
    // 跳转留言
    toLeaveMessage() {
      const ticketId = this.ticketId
      // 此处由系统内部跳转改为http链接方式跳转
      native.skipToUrl({
        targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/serviceprocess/message?ticketId=${ticketId}`
      })
    },
    getLogsInfo() {
      getTicketLogsForUser({ ticketId: this.ticketId }).then((resp) => {
        const ticketLogs = resp || []
        this.ticketLogsInfo = ticketLogs.map((item) => {
          return {
            title: item.title,
            imgs: item.fileUrls || [],
            description: item.desc,
            time: this.formatLogsTime(item.logTime)
          }
        })
      })
    },
    getAppointMentInfo() {
      const ticketId = this.ticketId
      return getPeriodsForAppointment({ ticketId }).then((resp) => {
        this.timeSelectEnum = resp || []
        this.initTimeSelectColoumns() // format后台时间数据
      })
    },
    getTikectInfo() {
      const uid = getCookie('uid') || ''
      const ticketId = this.ticketId
      if (!ticketId) return
      getTicketDetailForUser({ ticketId, uid }).then((resp) => {
        const { ticketInfo, appointmentInfo, businessInfo, ticketType, evaluationInfo, ticketHasBeenAssigned } = resp
        this.ticketInfo = ticketInfo || {}
        this.appointmentInfo = appointmentInfo || []
        this.businessInfo = businessInfo || {}
        this.ticketType = ticketType || 0
        this.evaluationInfo = evaluationInfo || {}
        this.appointmentSwitch = ticketInfo.appointmentSwitch || 0
        this.ticketHasBeenAssigned = Number(ticketHasBeenAssigned || '0')
        // 评价信息里面status为1 待评价才显示评价
        if (this.evaluationInfo.evaluationStatus && +this.evaluationInfo.evaluationStatus === 1) {
          this.showEvaluationSection = true
        }
      })
    },
    initTimeSelectColoumns() {
      const originData = this.timeSelectEnum
      if (!originData.length) return
      this.timeSelectMap = originData.reduce((cur, dist) => {
        return {
          ...cur,
          [dist.workingDate]: dist.workingHour
        }
      }, {})
      const dateMap = Object.keys(this.timeSelectMap)
      const curSelected = this.curSelectedFirst || dateMap[0]
      this.columns = [
        {
          values: dateMap
        },
        {
          values: this.timeSelectMap[curSelected].map((item) => {
            return {
              text: item.disabled ? `${item.timeStr}(约满)` : item.timeStr,
              disabled: item.disabled
            }
          })
        }
      ]
    },
    // 催单
    promptTicket() {
      if (this.fetching) return
      const params = {
        ticketId: this.ticketId,
        operatorUid: getCookie('uid')
      }
      this.fetching = true
      userUrgetTicket(params)
        .then((resp) => {
          this.fetching = false
          const { urgetResult } = resp
          if (+urgetResult === 1) {
            this.initPageInfo()
            Dialog.alert({
              title: '已为您完成催单',
              message: '您的问题我们已在快马加鞭处理中，请您耐心等待哦~',
              confirmButtonText: '确定'
            })
          } else if (+urgetResult === 0) {
            Dialog.alert({
              message: '您今天已经进行过催单啦，客服小妹正在全力处理中，请您耐心等待哦~',
              confirmButtonText: '确定'
            })
          }
        })
        .catch((_erro) => {
          this.fetching = false
        })
    },
    // 提交预约
    submitAppointInfo(info) {
      const ticketId = this.ticketId
      if (!ticketId) return
      const params = {
        kid: getCookie('uid') || '',
        ticketId,
        userType: 1,
        ...info
      }
      operationAppInfo(params).then((_resp) => {
        toast({
          msg: '提交成功',
          style: '1'
        })
        this.initPageInfo()
      })
    }
  }
}
</script>

<style lang="less" scoped>
  @import './index.less';
</style>
